import * as React from "react";
import { forwardRef } from "react";
const SvgMoney = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.827 3.346a1.25 1.25 0 0 0-2.5 0v.917a4.495 4.495 0 0 0 .168 8.987h2.164a1.995 1.995 0 1 1 0 3.99H8.25a1.25 1.25 0 1 0 0 2.5h3.077v.914a1.25 1.25 0 1 0 2.5 0v-.916a4.496 4.496 0 0 0-.168-8.988h-2.164a1.995 1.995 0 1 1 0-3.99h5.41a1.25 1.25 0 1 0 0-2.5h-3.078v-.914Z" }));
const ForwardRef = forwardRef(SvgMoney);
export default ForwardRef;
